import { Stack, TextField, Button } from '@mui/material'
import axios from 'axios'
import PageWrapper from 'hoc/PageWrapper'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { usePaymentsMutation } from 'services/payment'
import axiosInstance from 'store/axiosInstance'
import { v4 as uuidv4 } from 'uuid'

export const AzeriCard = () => {
  const { control, handleSubmit, watch } = useForm<any>({
    defaultValues: {
      paymentLotId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      browserScreenHeight: window.screen.height,
      browserScreenWidth: window.screen.width,
      browserTimeZone: '240',
      customerName: 'John Smith',
      customerPhone: '553210067',
    },
  })

  const [payment, { data, isSuccess }] = usePaymentsMutation()

  const onSubmit = async (values: any) => {
    const body = {
      ...values,
      id: uuidv4(),
    }

    await axiosInstance
      .get('/payments', { params: body, responseType: 'arraybuffer' })
      .then((response: any) => {
        const decoder = new TextDecoder('utf-8')
        const htmlString = decoder.decode(response)
        const blob = new Blob([htmlString], { type: 'text/html' })
        const url = URL.createObjectURL(blob)
        const newWindow = window.open(url, '_blank')
        if (newWindow) {
          newWindow.onload = () => {
            const form = newWindow.document.getElementById(
              'payment'
            ) as HTMLFormElement
            if (form) {
              form.submit()
            } else {
              console.error('Form not found in the new window')
            }
          }
        } else {
          console.error('Failed to open new window')
        }
      })
  }

  useEffect(() => {
    if (isSuccess) {
      let formBody: string[] = []
      for (let property in data) {
        if (data.hasOwnProperty.call(data, property)) {
          const encodedKey = encodeURIComponent(property)
          const encodedValue = encodeURIComponent((data as any)[property])
          formBody.push(encodedKey + '=' + encodedValue)
        }
      }
      const formBodyString = formBody.join('&')

      axios
        .post(
          'https://testmpi.3dsecure.az/cgi-bin/cgi_link',
          formBodyString.toString(),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }
        )
        .then((response) => {
          console.log('Response:', response.data)
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    }
  }, [isSuccess])

  return (
    <PageWrapper>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1>Azericard Testing Page</h1>
        <Stack width="60%" spacing={2}>
          <Controller
            control={control}
            name="customerName"
            render={({ field }) => <TextField {...field} label="Customer name" />}
          />
          <Controller
            control={control}
            name="customerPhone"
            render={({ field }) => <TextField {...field} label="Customer phone" />}
          />
          <Controller
            control={control}
            name="paymentLotId"
            render={({ field }) => <TextField {...field} label="Payment lot" />}
          />
          <Button
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            type="submit"
          >
            Submit
          </Button>
        </Stack>
      </form>
    </PageWrapper>
  )
}
